import React, { memo } from 'react';
import NumberFormat from 'react-number-format';
import { number } from 'prop-types';

const CurrencyLabel = ({ value }) => (
  <NumberFormat value={value} displayType="text" thousandSeparator decimalScale={2} fixedDecimalScale />
);

CurrencyLabel.propTypes = {
  value: number,
};

CurrencyLabel.defaultProps = {
  value: 0,
};


export default memo(CurrencyLabel);
